import styled from 'styled-components';

export const StyledClipboardWrapper = styled.div`
  width: unset !important;
`;
